
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "commitHash": "e1723ab725df70755b4cd73b75aa981f913d0d5c",
    "version": "11.1.0"
};
/* tslint:enable */
